import React, { useState, useEffect } from "react";
import { Navigation } from "../components/navigation";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { Project } from "../constants/interfaces";
import { Outlet } from "react-router-dom";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Projects = () => {
  const [projectData, setProjectData] = useState<Project[]>([]);

  useEffect(() => {
    setProjectData(JsonData.Projects);
  }, []);

  return (
    <div>
      <Outlet />
      <Navigation />
      <div className="container page-container">
        <div className="text-center mb-5">
          <h1>Current Projects</h1>
        </div>
        <div className="row justify-content-center">
          {projectData.map((project: Project, index) => (
            !project.disabled ? (
              <div className="center-block col-lg-4 mx-auto" key={index}>
                <div className="card h-100 d-flex flex-column align-items-center" style={{ marginBottom: '20px' }}>
                  <div className="image-container d-flex justify-content-center align-items-center" style={{ height: '150px', width: '100%' }}>
                    <img
                      src={project.image}
                      className="img-fluid center-block"
                      alt={project.title}
                      style={{ maxHeight: '100%', maxWidth: '100%' }}
                    />
                  </div>
                  <div className="card-body d-flex flex-column align-items-center text-center">
                    <h5 className="card-title">{project.title}</h5>
                    <p className="card-text h-25">{project.description}</p>
                    <a href={project.infoLink} type="button" className="btn btn-primary" style={{ color: '#ffffff', backgroundColor: '#0573e8' }}>Learn More</a>
                  </div>
                </div>
              </div>
            ) : null
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
